/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de etiquetado.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmEtiquetado from "../../inventarios/FrmEtiquetado.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmEtiquetadoPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmEtiquetado">
      <FrmEtiquetado />
    </SizeSoftXFrmPortatil>
  );
}
